import _ from 'lodash';
import React from 'react';
import { Grid } from 'semantic-ui-react';

export const initialValues = (qryType="") => {
    return {
      "recentQryList": [],
      "loading": false,
      "mockResponseRequired": false,
      "requestid": null,
      "saveTo": null,
      "qryInput": {
          "qryType":  qryType,  //  "BOL" / "ADCVD" / "CR"\
          "requestid": null,
          "searchParams": []
      },
      "qryOutput": {
          "outputType": "", // "qryInput", "recentQry", "",
          "responseParams": {}
      }
  }
}

export const qryColor = {
  adcvd: "#AA7104",
  bol: "#226AD7",
  cr: "rgb(215, 29, 122)",
  hts: "#1DA0D7",
  mid: "#501DD7",
  ib: "#f2711c",
  es: "rgb(2, 226, 178)",
  errorBackground: "#f9d1d1",
  errorColor: "#D50505"
}
export const checkResponse = response => {
    if (!response.data || !response.data.eventMessage || response.data.code === 400) {
      return false
    } else return response
}

// import store from '../store'
// import {
//   setErrorMessage
// } from '../actions'

export const JSONDisplayer = (children) => {
  const noCirculars = v => {
    const set = new Set; 
    const noCirculars = v => {
      if(Array.isArray(noCirculars))
        return v.map(noCirculars);
      if(typeof v === "object" && v !== null) {
        if(set.has(v)) return undefined;
        set.add(v);
  
        return Object.fromEntries(Object.entries(v)
         .map(([k, v]) => ([k, noCirculars(v)])));
      }
      return v;
    };
    return noCirculars(v);
  };
  children = noCirculars(children);
  if(children===null)return "N/A";
  let copyobject = {};
  for(let onekey of Object.keys(children)){
    if(!children[onekey])continue;
    if(children[onekey] == "N/A")continue;
    if((children[onekey]+"").toUpperCase().trim() == "DOCUMENT NONE")continue;
    if((children[onekey]+"").toLowerCase().trim() == "STATUS_CODE_NONE")continue;
    if((children[onekey]+"").toLowerCase().trim().includes("<null>"))continue;
    
    if(children[onekey] == -1)continue;
    if(JSON.stringify(children[onekey]) == "{}")continue;
    copyobject[onekey] = children[onekey];
  }
  console.log('children: ', children);
  return (
        Object.keys(copyobject).map((kkkkeeey, ix) => {
        if(kkkkeeey=="hidden")return <React.Fragment key={kkkkeeey + "rhkea" + ix}></React.Fragment>
        return <section className='row widthRow clickableJSONobj' key={kkkkeeey + "rhea" + ix} style={{ border: '1px solid #ccc',borderRight:'0px',display: 'flex'}}>
          <React.Fragment>
            {typeof copyobject[kkkkeeey] == 'object' ?
            <React.Fragment>
              <div className='width-4' width = {4} style={{ paddingLeft: '2px'  }} >
                {!(kkkkeeey.match(/^[0-9]+$/g)) &&
                  <React.Fragment>
                    {kkkkeeey.replace(/([a-z\d])([A-Z])/g, '$1' + ' ' + '$2')/*convert from camelcase*/}:<br />
                  </React.Fragment>
                }  </div>
                
                <div className='width-8' width = {12}>{JSONDisplayer(copyobject[kkkkeeey])}</div>
                {/* <div  width = {2}></div> */}
                </React.Fragment>
              :

              <React.Fragment>
                <Grid.Column  width = {4} style={{ verticalAlign: 'top', paddingLeft:'2px' }}>
                  {kkkkeeey.replace(/([a-z\d])([A-Z])/g, '$1' + ' ' + '$2')/*convert from camelcase*/}
                  :&nbsp;
                </Grid.Column>
                <Grid.Column  width = {12}>
                  <React.Fragment>{copyobject[kkkkeeey]}</React.Fragment>


                </Grid.Column>
                {/* <Grid.Column  width = {2}></Grid.Column> */}
              </React.Fragment>
            }


          </React.Fragment>
        </section>


      })
    
  )
}

export const  decamelize = (str, separator) => {
	separator = typeof separator === 'undefined' ? ' ' : separator;
	return _.startCase(str).replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
        .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
}

export const printThisObjectClickable = (potentiallyajsonobject, keyforobject, parentThis)=>{

  
  let stateforkey = 'uncamelize'+keyforobject;
  
  if(potentiallyajsonobject === null)return "N/A";//null is an object!
  if(typeof potentiallyajsonobject == 'object'){
    return <React.Fragment><button style={{cursor:'pointer'}} href="#" onClick={()=>{
        parentThis.setState({[stateforkey]:!parentThis.state[stateforkey]})
      }}>
        
        <i className={`blue ${parentThis.state[stateforkey]?"minus":"plus"} icon`} style={{float:'left'}}></i>
        Show {parentThis.state[stateforkey]?"Less":"More"}</button>
        {parentThis.state[stateforkey] &&
          <JSONDisplayer>{potentiallyajsonobject}</JSONDisplayer>
        }
      </React.Fragment>;
  }
  return potentiallyajsonobject;

}

export const  convert = (unixtimestamp) => {
  // Months array
  var months_arr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
 
  // Convert timestamp to milliseconds
  var date = new Date(unixtimestamp);
 
  // Year
  var year = date.getFullYear();
 
  // Month
  var month = months_arr[date.getMonth()];
 
  // Day
  var day = date.getDate();
 
  // Hours
  var hours = date.getHours();
 
  // Minutes
  var minutes = "0" + date.getMinutes();
 
  // Seconds
  var seconds = "0" + date.getSeconds();
 
  // Display date time in MM-dd-yyyy h:m:s format
  var convdataTime = month+'-'+day+'-'+year+' '+hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
  
  return convdataTime;
  
 }

 export const displayDropDownItem = (value, dropdownList) => {
  let result = value;
  let item;
  if (dropdownList) {
    item = dropdownList.find((obj) => obj.value === value);
    if (item && item.text) {
      result += " - " + item.text;
    } else if (item && item.id) {
      result = item.id;
    }
  }
  return result;
};